<template>
  <div class="containerRepresentante">
    <div class="formulario">
      <div v-if="!requisicaoFinalizada" class="loading-overlay-div">
        <div class="spinner"></div>
      </div>

      <div v-if="requisicaoFinalizada" class="titleForm" style="display: inline-flex">
        <div style="width: 90%">
          <h3>Declarações</h3>
          <h5>
            Aqui estão todos os documentos disponíveis para o seu perfil, clicar em ler os termos e aceitar as regras estabelecidas.
          </h5>

          <!-- Slot opcional para conteúdo adicional no cabeçalho (ex.: LabelDisclaimer) -->
          <slot name="header-extra"></slot>

          <input
            class="field field-full"
            style="width: 20%; margin-left: 15px; margin-bottom: 5px; background-color: white"
            type="text"
            :placeholder="searchPlaceholder"
            v-model="filtroDocumento"
            @change="pesquisarDocumento"
          />
        </div>

        <div style="width: 10%; display: flex; justify-content: flex-end; align-items: flex-start; padding-top: 6px;">
          <!-- Ações do cabeçalho à direita -->
          <slot name="actions-extra-right">
            <div class="widget icons" v-if="showRefresh" style="display: inline-flex">
              <a
                @click.stop.prevent="atualizarGridDeclaracoes"
                class="ico__refresh"
                title="Atualizar"
                style="margin-top: 10px"
              >
                <Icon icon="ico-refresh" />
              </a>
            </div>
          </slot>
        </div>
      </div>

      <div v-if="requisicaoFinalizada" class="resumoForm">
        <div class="opcoesForm" v-if="!listaDocumentos || listaDocumentos.length === 0">
          <h3>Nenhum documento encontrado</h3>
        </div>

        <div v-if="listaDocumentos && listaDocumentos.length > 0">
          <!-- Grid Desktop -->
          <table class="table grid-desktop">
            <thead>
              <th style="width: 70%">Nome do documento</th>
              <th style="width: 25%">Ações</th>
              <th style="width: 5%"></th>
            </thead>
            <tbody>
              <tr v-for="(documentoObj, index) in documentosFiltrados" :key="index">
                <td>{{ documentoObj.NomeDocumento }}</td>
                <td>
                  <div class="widget icons produtos" style="display: inline-flex">
                    <button
                      class="btnBlue"
                      style="cursor: pointer; font-size: smaller; border-color: white;"
                      v-if="!documentosCliente.some(p => p.TemplateId === documentoObj.TemplateId)"
                      @click="abrirTermos(documentoObj.TemplateId)"
                    >
                      Ler o termo
                    </button>

                    <button
                      class="btnBlue"
                      style="cursor: default; background-color: #5E84C3; font-size: smaller; border-color: white;"
                      v-if="documentoAssinadoSemPendencia(documentoObj.TemplateId)"
                      disabled="disabled"
                    >
                      Termo aceito
                    </button>

                    <button
                      class="btnBlue"
                      style="cursor: pointer; font-size: smaller; border-color: white; background-color: #252525;"
                      @click="lerTermos(documentoObj.TemplateId)"
                    >
                      Ver termo
                    </button>

                    <button
                      class="btnBlue"
                      style="cursor: pointer; font-size: smaller; border-color: white; background-color: #252525;"
                      v-if="showStatusButton && existeAssinaturaPendente(documentoObj.TemplateId)"
                      @click="statusAssinatura(documentoObj.TemplateId)"
                    >
                      Status da Assinatura
                    </button>
                  </div>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <!-- Grid Mobile (ativado para todos conforme requisitado) -->
          <div class="grid-mobile">
            <div class="rows__carteiras">
              <div class="header__row">
                <div class="widget">
                  <p>Nome do documento</p>
                </div>
                <div class="widget">
                  <p>Situação da assinatura</p>
                </div>
              </div>

              <div v-for="(documentoObj, index) in documentosFiltrados" :key="'m-' + index">
                <div class="row__client" v-if="documentoObj.NomeDocumento">
                  <div class="info__client">
                    <div class="widget">
                      <p class="title__mobile">{{ documentoObj.NomeDocumento }}</p>
                    </div>

                    <div class="widget">
                      <p class="title__mobile">Situação do documento</p>
                      <p>{{ documentoAssinadoSemPendencia(documentoObj.TemplateId) ? 'Assinado' : 'Pendente' }}</p>
                    </div>

                    <div class="widget icons produtos" style="display: inline-flex">
                      <button
                        class="btnBlue"
                        style="cursor: pointer; font-size: smaller; border-color: white;"
                        v-if="!documentosCliente.some(p => p.TemplateId === documentoObj.TemplateId)"
                        @click="abrirTermos(documentoObj.TemplateId)"
                      >
                        Ler o termo
                      </button>
                      <button
                        class="btnBlue"
                        style="cursor: pointer; font-size: smaller; border-color: white; background-color: #252525;"
                        @click="lerTermos(documentoObj.TemplateId)"
                      >
                        Ver termo
                      </button>
                      <button
                        class="btnBlue"
                        style="cursor: pointer; font-size: smaller; border-color: white; background-color: #252525;"
                        v-if="showStatusButton && existeAssinaturaPendente(documentoObj.TemplateId)"
                        @click="statusAssinatura(documentoObj.TemplateId)"
                      >
                        Status da Assinatura
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Slot para injetar modais específicos, se necessário (ex.: PJ) -->
      <slot name="modals"></slot>
    </div>
  </div>

        <ModalAviso 
        :id="'ModalAvisoNovaVersao'"
        :titulo="'Atenção: Precisamos de uma nova assinatura'" 
        :labelOpcoes="'Houve uma atualização nas declarações. Para seguir com seu cadastro, pedimos que reenvie novamente o documento para os responsáveis.'"
        :botoes="[
            { texto: 'Entendi', emit: 'fechar' }
        ]"
        />

</template>

<script>
import { mapGetters } from 'vuex';
import Icon from '@/components/icons/Icon.vue';
import ModalAviso from '@/views/Cadastro/Utilitarios/ModalAviso.vue'

export default {
  name: 'DeclaracoesDocumentosList',
  components: { Icon, ModalAviso },
  props: {
    tipoClienteKey: { type: String, required: true },
    showStatusButton: { type: Boolean, default: false },
    showRefresh: { type: Boolean, default: false },
    useImpressaoFlag: { type: Boolean, default: false },
    enablePolling: { type: Boolean, default: true },
    searchPlaceholder: { type: String, default: 'Pesquisar' },
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      listaDocumentos: 'GET_LISTA_DOCUMENTOS',
      listaDocumentosCliente: 'GET_LISTA_DOCUMENTOS_CLIENTE',
    }),
    documentosFiltrados() {
      if (!this.listaDocumentos) return [];
      if (this.filtroDocumento === '') {
        return this.listaDocumentos.filter((doc) =>
          (doc.TipoCliente || '').toLowerCase().includes(this.tipoClienteKey.toLowerCase())
        );
      }
      if (this.filtroDocumento.length > 0) {
        return this.listaDocumentos.filter(
          (doc) =>
            (doc.NomeDocumento || '').toLowerCase().includes(this.filtroDocumento.toLowerCase()) &&
            (doc.TipoCliente || '').toLowerCase().includes(this.tipoClienteKey.toLowerCase())
        );
      }
      return this.listaDocumentos;
    },
  },
  data() {
    return {
      filtroDocumento: '',
      documentosCliente: [],
      requisicaoFinalizada: false,
      pollingId: null,
    };
  },
  async created() {
    await this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE');
  },
  async mounted() {
    await this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS');
    if (this.enablePolling) {
      this.pollingId = setInterval(() => {
        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE');
      }, 10000);
    }

  },
  beforeUnmount() {
    if (this.pollingId) {
      clearInterval(this.pollingId);
      this.pollingId = null;
    }
  },
  watch: {
    listaDocumentos(){
      if(this.listaDocumentos && this.listaDocumentos.some(a=> a.AlterouVersaoComAssinatura == true))
      {
        this.$store.commit('SET_MODAL_AVISO', 'ModalAvisoNovaVersao');
      }
    },
    listaDocumentosCliente() {
      this.requisicaoFinalizada = true;
      console.log(this.listaDocumentosCliente);
      if (this.listaDocumentosCliente) {
        this.documentosCliente = this.listaDocumentosCliente;
      }
    },
  },
  methods: {
    pesquisarDocumento() {},
    async atualizarGridDeclaracoes() {
      if (!this.showRefresh) return;
      this.requisicaoFinalizada = false;
      await this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE');
    },
    async verificarMotivoDocumentoPendente(){
      await this.$store.dispatch('FETCH_CONSULTA_DOCUMENTO_VERSAO');
    },
    abrirTermos(id) {
      this.$store.commit('SET_MODAL_TERMOS_DOCUMENTOS', id);
      this.$store.commit('SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE', false);
      if (this.useImpressaoFlag) {
        // No abrirTermos, impressão não é habilitada
        this.$store.commit('SET_MODAL_TERMOS_DOCUMENTOS_IMPRESSAO', false);
      }
    },
    lerTermos(id) {
      const habImpressao = this.useImpressaoFlag && this.existeAssinaturaPendente(id);
      this.$store.commit('SET_MODAL_TERMOS_DOCUMENTOS', id);
      if (this.useImpressaoFlag) {
        this.$store.commit('SET_MODAL_TERMOS_DOCUMENTOS_IMPRESSAO', !!habImpressao);
      }
      this.$store.commit('SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE', true);
    },
    statusAssinatura(id) {
      const obj = this.documentosCliente.filter(
        (p) => p.TemplateId === id && p.StatusAssinatura == 'Pendente'
      )[0];
      if (obj && obj.DeclaracaoGuid) {
        this.$store.commit('SET_MODAL_ASSINATURA_STATUS', obj.DeclaracaoGuid);
      }
    },
    documentoAssinadoSemPendencia(templateId) {
      const hasTemplate = this.documentosCliente.some((p) => p.TemplateId == templateId);
      const hasPending = this.documentosCliente.some(
        (p) => p.TemplateId == templateId && p.StatusAssinatura == 'Pendente'
      );
      return hasTemplate && !hasPending;
    },
    existeAssinaturaPendente(templateId) {
      return this.documentosCliente.some(
        (p) => p.TemplateId === templateId && p.StatusAssinatura == 'Pendente'
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.produtos .btnBlue {
  height: 40px;
  font-family: 'Inter', sans-serif;
  background-color: #00235c;
  color: white;
  border: 1px solid #00235c;
  border-radius: 8px;
  cursor: pointer;
}

.formulario {
  margin-top: 20px;
  width: 100%;
  margin-bottom: 10px;
  font-family: 'Inter', sans-serif;
  border: 1px solid #eaecf0;
  border-radius: 8px;

  .titleForm {
    background-color: white;
    border-bottom: 1px solid #eaecf0;
    width: 100%;

    .btnBlue {
      height: 40px;
      font-family: 'Inter', sans-serif;
      background-color: #00235c;
      color: white;
      border: 1px solid #00235c;
      border-radius: 8px;
      width: 100px;
      cursor: pointer;
    }

    h3 {
      margin-left: 20px;
      color: #101828;
      font-weight: 500;
      font-family: 'Inter', sans-serif;
    }

    h5 {
      margin-top: 5px;
      margin-left: 20px;
      margin-block-start: 0;
      color: #667085;
      font-weight: 500;
      font-family: 'Inter', sans-serif;
    }
  }

  .resumoForm {
    width: 100%;

    .opcoesForm {
      margin-left: 30%;
      display: grid;
      justify-content: space-between;
      align-content: space-between;
      align-items: center;
      justify-items: center;
      padding: 30px 0px 30px 0px;

      h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 500;
        font-family: 'Inter', sans-serif;
      }

      img {
        height: 48px;
        width: 48px;
      }

      .btnBlue {
        height: 40px;
        font-family: 'Inter', sans-serif;
        background-color: #00235c;
        color: white;
        border: 1px solid #00235c;
        border-radius: 8px;
        width: 350px;
        cursor: pointer;
      }
    }
  }
}

/* Grid Mobile: aplicar espaçamento lateral maior (30px) para legibilidade */
.grid-mobile {
  display: none;
}

@media (max-width: 768px) {
  .grid-desktop {
    display: none;
  }
  .grid-mobile {
    display: block;
    padding: 0 30px; /* Preferência do usuário para margens laterais maiores */
  }
  .row__client {
    background: #fff;
    border: 1px solid #eaecf0;
    border-radius: 8px;
    padding: 12px 12px 16px 12px;
    margin-bottom: 12px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  }
  .title__mobile {
    font-weight: 600;
    margin-bottom: 4px;
  }
}
</style>
